const prefix = "NOTES_";

export const LIST_SET_FILTERS = prefix + "LIST_SET_FILTERS";
export const LIST_FAILED = prefix + "LIST_FAILED";
export const LIST_STARTED = prefix + "LIST_STARTED";
export const LIST_SUCCEEDED = prefix + "LIST_SUCCEEDED";
export const EDIT_CLEAR = prefix + "EDIT_CLEAR";
export const EDIT_DELETE_FAILED = prefix + "EDIT_DELETE_FAILED";
export const EDIT_DELETE_STARTED = prefix + "EDIT_DELETE_STARTED";
export const EDIT_DELETE_SUCCEEDED = prefix + "EDIT_DELETE_SUCCEEDED";
export const EDIT_GET_FAILED = prefix + "EDIT_GET_FAILED";
export const EDIT_GET_STARTED = prefix + "EDIT_GET_STARTED";
export const EDIT_GET_SUCCEEDED = prefix + "EDIT_GET_SUCCEEDED";
export const EDIT_SAVE_FAILED = prefix + "EDIT_SAVE_FAILED";
export const EDIT_SAVE_STARTED = prefix + "EDIT_SAVE_STARTED";
export const EDIT_SAVE_SUCCEEDED = prefix + "EDIT_SAVE_SUCCEEDED";
export const EDIT_SET_DATA = prefix + "EDIT_SET_DATA";
export const STATE_HIDE_ERROR = prefix + "STATE_HIDE_ERROR";
export const STATE_RESET = prefix + "STATE_RESET";
export const STATE_UNLOAD = prefix + "STATE_UNLOAD";
